<template>
  
  <div class="content">
    <ProgressBar ref="progressBar" />
    <b-navbar type="light" variant="light" sticky>
        <b-navbar-nav>
          <b-button pill variant="secondary" :to="urlBack()" v-if="hasBack()"><b-icon icon="caret-left" aria-hidden="true"></b-icon>Retour</b-button>

          <b-navbar-brand tag="h1" >Envoyer un email <span v-if="companies.length>0">à {{ companies.length }} société<span v-if="companies.length>1">s</span> |&nbsp;</span></b-navbar-brand>
          <span v-if="companies.length>0">
            <select v-model="company" @change="loadTemplate()">
              <option v-for="(company, index) in companies" :key="company.id" :value="company">
                {{ index+1 }} {{ company.name }}
              </option>
            </select>
            <button @click="sendAll()" class="btn btn-primary">Envoyer tous les emails</button>
        </span>
        </b-navbar-nav>
      </b-navbar>


    <div class="container-fluid">
      
      <h5> 
        <span v-if="operation">{{ operation.code }} - {{ operation.operationname }}</span><br />
        <span v-if="eu">{{ eu.name }}</span><br />
        <span v-if="ee">{{ ee.name }}</span><br />
        <span v-if="account">{{ account.name }}</span>
      </h5>
      Modèle de mail : 
      <select v-model="template_id" @change="loadTemplate()">
        <option v-for="template in templates" :key="template.id" :value="template.id">
          {{ template.text }}
        </option>
      </select>
      <!-- <div>
        {{ template_content }}
      </div> -->
    
    <form v-if="template_content" @submit="onSubmit">
      <table>
        <tr><td>De</td>      <td><input v-model="template_content.from"    type="text" class="form-control" /></td></tr>
        <tr><td>A</td>       <td><input v-model="template_content.to"      type="text" class="form-control" /></td></tr>
        <tr><td>Copie</td>   <td><input v-model="template_content.cc"      type="text" class="form-control" /></td></tr>
        <tr><td>C.Cachée</td><td><input v-model="template_content.bcc"     type="text" class="form-control" /></td></tr>
        <tr><td>Sujet</td><td><input v-model="template_content.subject" type="text" class="form-control" /></td></tr>
        <tr><td>Texte</td><td>
          <div style="padding:8px 12px;background-color:white;" 
            contenteditable="true"
            @input="doneEdit"
            v-html="template_content.originalhtml" >
          </div>  
        </td></tr>
      </table>
      <input type="submit" class="btn btn-primary" value="Envoyer" />
    </form>
  </div>

  </div>
</template>

<script>
  import common from '../common/pages.js'

  import ProgressBar from '../ProgressBar.vue'
        
  export default {
      components: {
        ProgressBar,
      },
    data() {
      return {
        all_subscriptions: this.$route.query.all_subscriptions || '',
        euid: this.$route.query.euid || '',
        eu : null,
        eeid: this.$route.query.eeid || '',
        ee: null,
        operationid: this.$route.query.operationid || '',
        operation:null,
        accountid: this.$route.query.accountid || '',
        account:null,
        template_id: this.$route.query.template_id,
        template_content: "",
        templates: [{id:1,text:'modele 1'}, {id:2, text:'model 2'}],
        companies: [],
        company: null
      }
    },
    methods: {
      ...common.methods,
      startProgress(max, label) {
        this.$refs.progressBar.startProgress(max, label); // Appelle la méthode du composant enfant
      },
      stopProgress() { 
        this.$refs.progressBar.stopProgress(); // Appelle la méthode du composant enfant
      },
      incrementProgress(item) { 
        this.$refs.progressBar.incrementProgress(item); // Appelle la méthode du composant enfant
      },
      async loadTemplate(){
        try {
          var url = ''
          if(this.company) {
            url = `/admin/getemailtemplate?templateid=${this.template_id}&euid=${this.euid}&eeid=${this.company.id}&operationid=${this.operationid}&accountid=${this.company.ownerid}`
            console.log(url)
            var response = await this.$http.get(url)    
          }
          else {
            url = `/admin/getemailtemplate?templateid=${this.template_id}&euid=${this.euid}&eeid=${this.eeid}&operationid=${this.operationid}&accountid=${this.accountid}`
            response = await this.$http.get(url)    
          }
        if(response.data) {
          this.template_content = response.data.content
          this.template_content.originalhtml = this.template_content.html
        }
      } catch(err) {
          let error = JSON.parse( JSON.stringify(err) )
					swal("Erreur", JSON.stringify(err.response ? err.response.data : error.message), "error");
      }
      },
      doneEdit(evt) { 
        this.template_content.html = evt.srcElement.innerHTML
      },
      async onSubmit(event) {
        event.preventDefault();
        console.log("Form.vue:onSubmit():postData", this.template_content)
        try {
          let response = await this.$http.post("/admin/sendemail", this.template_content);

          swal({title:"Envoyé", text:"Email envoyé avec succès", icon:"success", timer:1500,buttons: false} );

          let redirectUrl = this.$route.query.redirectUrl
          this.$router.replace(redirectUrl);
        } catch (err) {
              console.error("SendEmail:onSubmit(): "+this.endpoint, err.response?err.response.data:err);
              swal("Erreur", (err.response.data?JSON.stringify(err.response.data):JSON.stringify(err.message)), "error");
        }
      },

      async sendAll() {
        this.startProgress(this.companies.length, "Envoi des emails en cours")

        for(let company of this.companies) {
            
          try {
            var url = `/admin/getemailtemplate?templateid=${this.template_id}&euid=${this.euid}&eeid=${company.id}&operationid=${this.operationid}&accountid=${company.ownerid}`
            console.log(url)
            this.incrementProgress(company.name)
            var response = await this.$http.get(url)   
            console.log(response) 
            if(response.data) {
              this.template_content = response.data.content
              this.template_content.originalhtml = this.template_content.html

              await this.$http.post("/admin/sendemail", this.template_content);
            }
          } catch(err) {
              console.error(`SendEmail:onSubmit(): ${company.name}, ${url}`, err);
              let result = await swal({
                  title:"Erreur", 
                  text:`Lors de l'envoi à ${company.name} : ${err}`, 
                  icon:'error',
                  reverseButtons: true,         // Inverse l'ordre des boutons (optionnel)
                  buttons: {
                    cancel:  "Arrêter l'envoi",
                    confirm: {text:"Continuer à envoyer", className:"btn btn-info"},
                    },
                  } )
              console.log("swal", result)
              if (!result) 
                 break;
          }
        }
        await this.sleep(1500)
        this.stopProgress()
      }
    },  
    mounted() {
      this.$http.get(`/admin/getemailtemplatelist?operationid=${this.operationid}&all_subscriptions=${this.all_subscriptions}&euid=${this.euid}&eeid=${this.eeid}&accountid=${this.accountid}`)
      .then(response => {
        console.log("getemailtemplatelist response", response.data)
        this.templates = response.data.templates
        this.eu = response.data.eu
        this.euid = response.data.eu.id
        this.ee = response.data.ee
        this.account = response.data.account
        this.operation = response.data.operation
        this.companies = response.data.companies || []

        if( this.template_id ){
          this.loadTemplate()
        }
      });

  
    }
  }
</script>